import React from 'react';
import './styles/Skills.css';

const skills = [
	{
		name: 'HTML5',
		imgSrc: 'https://i.imgur.com/RQW6JgU.png',
		description: 'Markup language for web pages.',
	},
	{
		name: 'CSS',
		imgSrc: 'https://i.imgur.com/T0eS9IW.png',
		description:
			'Style sheet language used for describing the look of web pages.',
	},
	{
		name: 'JavaScript',
		imgSrc: 'https://i.imgur.com/cN3mSiG.png',
		description: 'Programming language for web development.',
	},
	{
		name: 'MongoDB',
		imgSrc: 'https://i.imgur.com/7NMZvS8.png',
		description: 'NoSQL database for scalable and flexible storage.',
	},
	{
		name: 'Express.js',
		imgSrc: 'https://i.imgur.com/JBo9WeC.png',
		description: 'Web application framework for Node.js.',
	},
	{
		name: 'React',
		imgSrc: 'https://i.imgur.com/SSjHcru.png',
		description: 'JavaScript library for building user interfaces.',
	},
	{
		name: 'Node.js',
		imgSrc: 'https://i.imgur.com/V50CpND.png',
		description: 'JavaScript runtime for server-side development.',
	},
	{
		name: 'TypeScript',
		imgSrc: 'https://i.imgur.com/YzCyIZl.png',
		description: 'A superset of JavaScript that compiles to plain JavaScript.',
	},
	{
		name: 'Bootstrap',
		imgSrc: 'https://i.imgur.com/MoL3myV.png',
		description: 'Front-end framework for developing responsive websites.',
	},
	{
		name: 'Postman',
		imgSrc: 'https://i.imgur.com/C1GeCfs.png',
		description: 'API testing and development tool.',
	},
	{
		name: 'MySQL',
		imgSrc: 'https://i.imgur.com/HdDmezc.png',
		description: 'Relational database management system.',
	},
	{
		name: 'Tailwind CSS',
		imgSrc: 'https://i.imgur.com/vhxEaU2.png',
		description: 'Utility-first CSS framework for rapid UI development.',
	},
	{
		name: 'Tailwind (Second)',
		imgSrc: 'https://i.imgur.com/TcZSg99.png',
		description: 'A utility-first CSS framework for UI design.',
	},
];

const Skills = () => {
	return (
		<div name="skills" className="skills-container">
			<div className="skills-list">
				<ul className="d-flex flex-row flex-wrap justify-content-center">
					{skills.map((skill, index) => (
						<li key={index} className="skill-group-item list-unstyled">
							<div className="skill-item">
								<img src={skill.imgSrc} alt={skill.name} />
								<h4>{skill.name}</h4> {/* Teknoloji adı */}
								<p className="skill-description">{skill.description}</p>{' '}
								{/* Açıklama, hover ile görünecek */}
							</div>
						</li>
					))}
				</ul>
			</div>
		</div>
	);
};

export default Skills;
